import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ComputerIcon, DriveIcon, DropboxIcon, List, ListItem } from "@activecollab/components";
import PropTypes from "prop-types";
import ConnectDropboxChooser from "../../component.dropbox_chooser.jsx";
import ConnectGooglePicker from "../../container.google_picker.jsx";
import { useFileIntegrations } from "../../Hooks/useFileIntegrations.jsx";

export const AttachmentMenuList = ({ onCloseMenu, openFileWindow, onAttachFromDropbox, onAttachFromGoogleDrive }) => {
  const { t } = useTranslation();
  const { showDropbox, dropboxAppKey, showGoogleDrive, googleDriveAppId, googleDriveClientId, googleDriveApiKey } =
    useFileIntegrations();

  const handleOpenFileWindow = useCallback(() => {
    typeof openFileWindow === "function" && openFileWindow();
    typeof onCloseMenu === "function" && onCloseMenu();
  }, [onCloseMenu, openFileWindow]);

  const handleGoogleDriveAttach = useCallback(
    (files) => {
      typeof onAttachFromGoogleDrive === "function" && onAttachFromGoogleDrive(files);
      typeof onCloseMenu === "function" && onCloseMenu();
    },
    [onAttachFromGoogleDrive, onCloseMenu]
  );

  const handleDropboxAttach = useCallback(
    (files) => {
      typeof onAttachFromDropbox === "function" && onAttachFromDropbox(files);
      typeof onCloseMenu === "function" && onCloseMenu();
    },
    [onAttachFromDropbox, onCloseMenu]
  );

  return (
    <List className="tw-py-2">
      <ListItem onClick={handleOpenFileWindow}>
        <ComputerIcon className="tw-mr-2 tw-w-5 tw-h-5 fill-900" />
        {t("From Computer")}
      </ListItem>
      {showDropbox ? (
        <ListItem className="tw-px-0">
          <DropboxIcon className="tw-mr-2 tw-w-5 tw-h-5 fill-900 tw-absolute tw-left-4" />
          <ConnectDropboxChooser
            className="tw-no-underline color-900 tw-grow tw-text-left tw-pl-11 tw-z-10"
            appKey={dropboxAppKey}
            label="Dropbox"
            onChange={handleDropboxAttach}
          />
        </ListItem>
      ) : null}
      {showGoogleDrive ? (
        <ListItem className="tw-px-0">
          <DriveIcon className="tw-mr-2 tw-w-5 tw-h-5 fill-900 tw-absolute tw-left-4" />
          <ConnectGooglePicker
            className="tw-no-underline color-900 tw-grow tw-text-left tw-pl-11 tw-z-10"
            clientId={googleDriveClientId}
            appId={googleDriveAppId}
            label="Google Drive"
            onChange={handleGoogleDriveAttach}
            apiKey={googleDriveApiKey}
          />
        </ListItem>
      ) : null}
    </List>
  );
};

AttachmentMenuList.propTypes = {
  onCloseMenu: PropTypes.func,
  onAttachFromDropbox: PropTypes.func,
  onAttachFromGoogleDrive: PropTypes.func,
  openFileWindow: PropTypes.func,
};
